/* eslint-disable */
import React from 'react';
import getUrlExtension from '@src/utils/get-url-extension';
import { withoutProps } from '@src/utils/data-utils';
import extendAppend from '@src/components/modal/__helper__/extend-append';
import styles from './index.less';
import Link from '@src/components/link';
import cx from 'classnames';
import ModalContainer from '@src/components/modal-container';
import Button, { buttonType } from '@src/components/button';
import { noop } from '@src/utils/common-util';

@extendAppend({ modalClassName: styles.modal })
export default class Video extends React.PureComponent {
  /**
   * 是否是 m3u8
   * @returns {boolean}
   */
  isM3u8() {
    const { src } = this.props;
    const { m3u8 = src.search('.m3u8') > 0 } = this.props;
    return m3u8;
  }

  getSpreadProps() {
    return withoutProps(this.props, [
      'generalPlayerIframeUrl',
      'm3u8PlayerIframeUrl',
      'src',
      'modal',
      'isModalCloseVisible',
      'onCloseCallback'
    ]);
  }

  /**
   * 渲染除了 m3u8 以外的视频
   * @returns {*}
   */
  renderGeneralPlayer() {
    const { src, generalPlayerIframeUrl, modal, onCloseCallback = noop } = this.props;
    return this.renderIframe({
      src: `${generalPlayerIframeUrl}?${encodeURIComponent(
        JSON.stringify({
          video: src,
          autoPlay: true /* m3u8 目前不提供自动播放支持 */
        })
      )}`,
      onClose: onCloseCallback,
      modal
    });
  }

  /**
   * 渲染 m3u8 视频
   * @returns {*}
   */
  renderM3u8PlayerIframeUrl() {
    const { src, m3u8PlayerIframeUrl, modal, onCloseCallback = noop } = this.props;
    return this.renderIframe({
      src: `${m3u8PlayerIframeUrl}?url=${encodeURIComponent(src)}`,
      onClose: onCloseCallback,
      modal
    });
  }

  renderIframe(props) {
    const { modal, src, wrapIframeClassName, wrapCloseClassName, onClose } = props;
    return (
      <React.Fragment>
        <ModalContainer modalState={modal.visible}>
          <div className={styles.videoContainer}>
            <iframe src={src} className={cx(styles.iframe, styles.videoBox, wrapIframeClassName)} allow='autoplay' {...this.getSpreadProps()} />
          </div>
          {modal &&
          <Button buttonType={buttonType.ROTATE} className={cx(styles.close, wrapCloseClassName)} onClick={() => {
            modal.onClose();
            onClose();
          }} />}
        </ModalContainer>
      </React.Fragment>
    );
  }

  render() {
    return this.isM3u8() ? this.renderM3u8PlayerIframeUrl() : this.renderGeneralPlayer();
  }
}

Video.defaultProps = {
  generalPlayerIframeUrl: '//zhcdn01.xoyo.com/xassets/iframe/video/0.0.x/index.html',
  m3u8PlayerIframeUrl: '//zhcdn01.xoyo.com/xassets/iframe/m3u8-media-play/0.0.x/index.html',
  width: '100%',
  height: '100%',
  frameBorder: 0,
  allowFullScreen: true
};
